import React from "react";
import Banner_JNCW_jpg_1 from "../../../assets/images/banner/jncw/jpg/banner-1.jpg";
import Banner_JNCW_jpg_2 from "../../../assets/images/banner/jncw/jpg/banner-2.jpg";
import Banner_JNCW_jpg_3 from "../../../assets/images/banner/jncw/jpg/banner-3.jpg";
import Banner_JNCW_jpg_4 from "../../../assets/images/banner/jncw/jpg/banner-4.jpg";
import Banner_JNCW_jpg_5 from "../../../assets/images/banner/jncw/jpg/banner-5.jpg";
import Banner_JNCW_jpg_6 from "../../../assets/images/banner/jncw/jpg/banner-6.jpg";
import Banner_JNCW_jpg_7 from "../../../assets/images/banner/jncw/jpg/banner-7.jpg";
import Banner_JNCW_jpg_8 from "../../../assets/images/banner/jncw/jpg/banner-8.jpg";

import Banner_JNCW_webp_1 from "../../../assets/images/banner/jncw/webp/banner-1.webp";
import Banner_JNCW_webp_2 from "../../../assets/images/banner/jncw/webp/banner-2.webp";
import Banner_JNCW_webp_3 from "../../../assets/images/banner/jncw/webp/banner-3.webp";
import Banner_JNCW_webp_4 from "../../../assets/images/banner/jncw/webp/banner-4.webp";
import Banner_JNCW_webp_5 from "../../../assets/images/banner/jncw/webp/banner-5.webp";
import Banner_JNCW_webp_6 from "../../../assets/images/banner/jncw/webp/banner-6.webp";
import Banner_JNCW_webp_7 from "../../../assets/images/banner/jncw/webp/banner-7.webp";
import Banner_JNCW_webp_8 from "../../../assets/images/banner/jncw/webp/banner-8.webp";

import BannerCarousel from "../../layouts/bannerCarousel";

const Pharmacy = () => {
//   const JNCWBanner = [
//     {
//       jpg: Banner_JNCW_jpg_1,
//       webp: Banner_JNCW_webp_1,
//     },
//     {
//       jpg: Banner_JNCW_jpg_2,
//       webp: Banner_JNCW_webp_2,
//     },
//     {
//       jpg: Banner_JNCW_jpg_3,
//       webp: Banner_JNCW_webp_3,
//     },
//     {
//       jpg: Banner_JNCW_jpg_4,
//       webp: Banner_JNCW_webp_4,
//     },
//     {
//       jpg: Banner_JNCW_jpg_5,
//       webp: Banner_JNCW_webp_5,
//     },
//     {
//       jpg: Banner_JNCW_jpg_6,
//       webp: Banner_JNCW_webp_6,
//     },
//     {
//       jpg: Banner_JNCW_jpg_7,
//       webp: Banner_JNCW_webp_7,
//     },
//     {
//       jpg: Banner_JNCW_jpg_8,
//       webp: Banner_JNCW_webp_8,
//     },
//   ];
  return (
    <>
      {/* <BannerCarousel BannerContent={JNCWBanner} /> */}
      <div className="container">
        <h4 className="my-5 fw-bolder text-header">
          JSA Pharmacy College of Medical Sciences
        </h4>

        <div className="lh-lg">
          <p className="text-justify pt-3">
           
          </p>

          <div className="mt-5">
            <h4 className="text-success  my-3 fw-bolder">Our Vision</h4>
            <ul className="">
              <li>
           We deliver outstanding Pharmacy education that addresses both community healthcare needs and the broader Pharmaceutical industry, drawing on our extensive expertise in Healthcare Profession.
              </li>
            </ul>
          </div>
          <div className="mt-5">
            <h4 className="text-success  my-3 fw-bolder">Our Mission</h4>
            <ul className="">
              <li className="">
              We are dedicated to achieving academic excellence by providing world-class Pharmacy education that equips individuals to face challenges effectively, bridging the gap between academia and industry to address societal needs.
              </li>
            </ul>
          </div>
        </div>
        <div className="my-4">
          <a href="https://jsapharmacy.in" target="_blank" rel="noreferrer">
            <button className="btn btn-primary">Read More...</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default Pharmacy;
